import type { UpdateShopRoutingLocationRuleDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateRoutingLocationRules(shopId: string) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation("patch", "/shops/{shopId}/routing-location-rules", {
    invalidate: invalidateShop,
    mapVariables: (requestBody: UpdateShopRoutingLocationRuleDto[]) => ({
      params: { path: { shopId } },
      body: requestBody,
    }),
  });
}
